// from https://developer.mozilla.org/ja/docs/Web/API/Notifications_API/Using_the_Notifications_API
function checkNotificationPromise() {
    try {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Notification.requestPermission().then();
    } catch (e) {
        return false;
    }

    return true;
}

export function requestPermission(): Promise<NotificationPermission> {
    if (!("Notification" in window)) {
        throw new Error("Notification API 非対応");
    }

    if (checkNotificationPromise()) {
        return Notification.requestPermission();
    }

    return new Promise((resolve) => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Notification.requestPermission((permission) => {
            resolve(permission);
        });
    });
}
